import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/index.vue'
import Login from '@/pages/Login/index.vue'
import My from '@/pages/My/index.vue'
import EditInfo from '@/pages/EditInfo/index.vue'
import Training from '@/pages/Training/index.vue'
import TrainingProgress from '@/pages/TrainingProgress/index.vue'
import ProgramDetail from '@/pages/ProgramDetail/index.vue'
import BindPhone from '@/pages/BindPhone/index.vue'
import Wallet from '@/pages/Wallet/index.vue'
import Invite from '@/pages/Invite/index.vue'
import Terms from '@/pages/Terms/index.vue'

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => {
    return err
  })
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home',
        keepAlive: true,
        showFooter: true,
        showTopBar: true,
        seo: {
          h1: 'PGEBet Official Links',
          h2: [
            'Latest Official Website & Support'
          ]
        }
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        keepAlive: false,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home',
        keepAlive: true,
        showFooter: true,
        showTopBar: true,
        seo: {
          h1: 'PGEBet Official Links',
          h2: [
            'Latest Official Website & Support'
          ]
        }
      }
    },
    {
      path: '/Training',
      name: 'Training',
      component: Training,
      meta: {
        title: 'Training',
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/TrainingProgress',
      name: 'TrainingProgress',
      component: TrainingProgress,
      meta: {
        title: 'TrainingProgress',
        keepAlive: false,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/ProgramDetail',
      name: 'ProgramDetail',
      component: ProgramDetail,
      meta: {
        title: 'ProgramDetail',
        keepAlive: false,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/BindPhone',
      name: 'BindPhone',
      component: BindPhone,
      meta: {
        title: 'BindPhone',
        keepAlive: false,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/Wallet',
      name: 'Wallet',
      component: Wallet,
      meta: {
        title: 'Wallet',
        keepAlive: false,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/Invite',
      name: 'Invite',
      component: Invite,
      meta: {
        title: 'Invite',
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/My',
      name: 'My',
      component: My,
      meta: {
        title: 'My',
        keepAlive: false,
        showFooter: true,
        showTopBar: true
      }
    },
    {
      path: '/EditProfile',
      name: 'EditProfile',
      component: EditInfo,
      meta: {
        title: 'EditProfile',
        keepAlive: false,
        showFooter: false,
        showTopBar: false
      }
    },
    {
      path: '/Terms',
      name: 'Terms',
      component: Terms,
      meta: {
        title: 'Terms',
        keepAlive: false,
        showFooter: false,
        showTopBar: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js